import {
  Globe,
  investmentIcon,
  SendIcon,
  ZeroForex,
  ManageCard as ManageCardIcon,
} from "./../../Public/assets/index";
import React from "react";
import CreditCard from "./CreditCard";
import { Button } from "./../../Components/ui/button";
import { SkeletonDebitCard } from "./../../Components/skeleton";

const DebitCard = ({
  setIsOpen,
  setCurrentFlow,
  cardDetailsResponse,
  isLoadingCard,
  isFetchingCard,
}) => {
  const cardData = cardDetailsResponse?.data;

  // Determine if card is frozen based on status
  const isCardFrozen =
    cardData?.status &&
    cardData.status !== "ACTIVE" &&
    cardData.status !== "APPROVED";

  // Show loading state when fetching updates
  const isUpdating = isFetchingCard && !isLoadingCard;

  // Handle unfreeze button click - open manage card modal
  const handleUnfreeze = () => {
    setCurrentFlow("ManageCard");
    setIsOpen(true);
  };

  const features = [
    {
      icon: <img src={investmentIcon} alt="investment" className="w-8 h-8" />,
      title1: "International online",
      title2: "payments",
    },
    {
      // No forex on same-currency spends
      icon: <img src={ZeroForex} alt="send" className="w-8 h-8" />,
      title1: "No forex on",
      title2: "same-currency spends",
    },
    {
      icon: <img src={SendIcon} alt="send" className="w-8 h-8" />,
      title1: "Automatic currency",
      title2: "conversion",
    },
    {
      icon: <img src={Globe} alt="globe" className="w-8 h-8" />,
      title1: "Setup recurring",
      title2: "subscriptions",
    },
  ];

  if (isLoadingCard) {
    return <SkeletonDebitCard />;
  }

  return (
    <div className="w-full lg:px-40 CardBackground my-10">
      <div className="flex flex-col rounded-lg p-[22px] bg-debit-card-bg shadow-debit-card gap-6">
        {/* Header - Title and Manage Card Button */}
        <div className="flex justify-between items-center">
          <h2 className="text-gray-800 font-geomanistRegular font-normal text-[22px] leading-[100%] tracking-[0px]">
            Here's your debit card
          </h2>
          <Button
            onClick={() => {
              setCurrentFlow("ManageCard");
              setIsOpen(true);
            }}
            variant="primary"
            size="default"
            className="w-auto border-blueish rounded-[8px] gap-2 font-geomanistBold font-normal text-[14px] leading-[20px] tracking-[0px] text-center"
          >
            <img src={ManageCardIcon} alt="" className="w-6 h-6" />
            Manage Card
          </Button>
        </div>

        {/* Card and Grid Section */}
        <div className="flex flex-col xl:flex-row gap-6 lg:items-center">
          {/* Debit Card - 40% on desktop */}
          <div className="w-full xl:w-[40%]">
            <CreditCard
              cardNumber={cardData?.cardNo}
              expiryDate={cardData?.expiry}
              cvv={cardData?.cvv}
              cardHolderName={cardData?.nameOnCard}
              cardType={cardData?.cardType}
              showUnlockButton={true}
              onDateSubmit={(dob) => console.log("DOB submitted:", dob)}
              isFrozen={isCardFrozen}
              onUnfreeze={handleUnfreeze}
              isStatusUpdating={isUpdating}
            />
          </div>

          {/* Features Grid - 60% on desktop */}
          <div className="w-full  xl:w-[60%]">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 lg:gap-6 h-full">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="flex bg-white flex-col items-start gap-3 p-4 hover:bg-gray-50 transition-colors rounded-[10px] min-h-[131px]"
                >
                  <div className="flex flex-col items-start gap-3">
                    <div className="text-blue-600">{feature.icon}</div>
                    <div className="font-geomanistRegular font-normal text-base leading-[100%] tracking-[0%] text-blackShade">
                      <div className="xl:inline">{feature.title1}</div>
                      <div className="xl:inline xl:ml-1">{feature.title2}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Learn More Button */}
        <div className="flex justify-end">
          <Button
            onClick={() =>
              window.open(
                "https://help.borderless.world/portal/en/kb/borderless-multicurrency-account/debit-card",
                "_blank",
                "noopener,noreferrer"
              )
            }
            variant="outline"
            className="w-[111px] h-[40px] rounded-[8px] border-[1.5px] border-[#0061D3] px-[13px] py-[10px] gap-[4px] font-geomanistRegular font-normal text-[14px] leading-[20px] tracking-[0px] !bg-transparent"
          >
            Learn More
            <span>&gt;&gt;</span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DebitCard;
